<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XWUnDE/tc-custom/9781683358640.jpg?1718106147833" alt="This image is the cover for the book Lights, Camera, Danger!, Alien Superstar"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lights, Camera, Danger!, Alien Superstar
      </h1>
      <p class="bookDescription body article font2">
        <b>A six-eyed teenage alien’s future in Hollywood—and on Earth—is at risk when a visitor from his home planet arrives in this humorous adventure.</b><br/><br/>After escaping his oppressive red dwarf planet and landing a role on a popular Hollywood sitcom, Buddy Burger seems destined for high-flying success. His legions of fans love his six eyes, his suction cup feet, and even his excessive need for avocados. It seems nothing can stop his rise to super-stardom—until the arrival of Citizen Cruel, a shape-shifting Squadron member sent from Buddy’s home planet to bring him back by any means necessary. Will Buddy conquer this clever and unpredictable enemy? How long can he continue to keep his alien identity secret from his friends and fans? Is there enough guacamole on Earth to sustain him? And chips to go with it?<br/><br/><b>Praise for <i>Alien Superstar</i></b><br/><br/><b>“Action, suspense, and big laughs!” —Jeff Kinney, author of the Diary of a Wimpy Kid series</b><br/><br/><b>“Henry Winkler and Lin Oliver keep us laughing while slipping in a lesson for kids—accept everyone as they are, even if they have suction cups for feet. . . . A super fun read for middle grades on up.” —Jennifer Garner</b><br/><br/><b>“A funny interstellar adventure.” —<i>SLJ Review</i></b><br/><br/><b>"Winkler and Oliver bring their sharply honed sense of comedy and extensive experience in the television industry to Buddy’s antics on the set. . . . This results in an endearingly strange protagonist that will resonate with any kid who has felt like an outsider. A sense of humor and empathy are required for this zany adventure.” —<i>Booklist</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Henry Winkler, Lin Oliver
      </h2>
      
      <p class="authorDescription body article">Henry Winkler is an Emmy Award–winning actor, writer, director, and producer who has created some of the most iconic TV roles, including Arthur “the Fonz” Fonzarelli on Happy Days and Gene Cousineau on Barry.Lin Oliver is a children’s book writer and a writer and producer for both TV and film. She is currently the executive director of the Society of Children’s Book Writers and Illustrators (SCBWI). They both live in Los Angeles.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Amulet Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15a3a16c